<template>
    <div class="auth-indication-root d-flex flex-column">
        <div class="overlay p-2 d-flex flex-column align-items-center justify-content-center white">
            <h3 class="color-inherit text-center color-white">
                {{ $t('components.smart.profileModule.authIndication.title') }}
            </h3>
            <h6 class="subtitle text-center color-white">
                {{ $t('components.smart.profileModule.authIndication.description') }}
            </h6>
        </div>
        <div class="overlay-path" />
        <div class="p-2 flex-grow d-flex align-items-center justify-content-center">
            <BaseButton
                class="logInBtn bold"
                variant="secondary"
                @click="
                    event => {
                        openLogIn(event);
                        $emit('click');
                    }
                "
            >
                {{ $t('components.smart.profileModule.authIndication.action') }}
            </BaseButton>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AuthIndication',
    methods: {
        openLogIn() {
            this.$interfaces.logInModule.toggleOpen();
        },
    },
};
</script>

<style scoped>
.auth-indication-root {
    position: relative;
    height: 400px;
}

@media only screen and (max-width: 600px) {
    .auth-indication-root {
        height: auto;
    }
}

.logInBtn {
    font-size: 16 px;
    width: 60%;
}
.color-white {
    color: white !important;
}

.overlay {
    position: relative;
    top: 0;
    height: 50%;
    right: 0;
    left: 0;
    border-radius: var(--border-radius) var(--border-radius) 0 0;

    background-color: var(--secondary);
}
.overlay-card {
    width: 100%;
    height: 30%;
}
.overlay-path {
    position: relative;
    transform: translateY(-0.2px);
    left: 0;
    right: 0;
    width: 100%;
    height: 40px;
    -webkit-clip-path: polygon(100% 0, 0 0, 0 36%);
    clip-path: polygon(100% 0, 0 0, 0 90%);
    background-color: var(--secondary);
}
.overlay-path-top {
    height: 40px;
    -webkit-clip-path: polygon(100% 0, 0 100%, 100% 100%);
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
}
</style>
